module.exports = "<div>\n\t<ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/routing-tabs/tab-header.html
// module id = OZzS
// module chunks = 12